export enum CancelationWay {
  FromCashRefund = 1,
  FromGymMembershipsScreen = 2
}
